import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextFieldCardCounter from '../../shared/TextFieldCardCounter';
import RowTitle from '../RowTitle';
import { color } from '../../../app/theme';
import Tooltip from '../../shared/Tooltip';
import icHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    inputBlock: {
      marginBottom: 4,
      borderRadius: 24,
      padding: '12px 16px',
      backgroundColor: color.$19,
      display: 'inline-block',
    },
    input: {
      width: 601,
    },
    inputTitle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '15px',
      color: color.$13,
      marginBottom: 6,
      '& > img': {
        marginLeft: 4,
      },
    },
  },
  {
    name: 'ReplySourceUrl',
  },
);

const ReplySourceUrl = ({
  isChecked,
  onSwitchChange,
  value,
  onChange,
  isSaved,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:advanceSettingContainer.replySourceUrl`)}
        tooltip={t(`${pathKey}:advanceSettingContainer.replySourceUrlTooltip`)}
        isChecked={isChecked}
        onSwitchChange={onSwitchChange}
        isEnableSwitch
        disabled={disabled}
      />
      {isChecked && (
        <div className={classes.inputBlock}>
          <div className={classes.inputTitle}>
            {t(`${pathKey}:advanceSettingContainer.replySourceUrlInputTitle`)}
            <Tooltip
              light
              placement="top"
              title={t(
                `${pathKey}:advanceSettingContainer.replySourceUrlInputTitleTooltip`,
              )}
            >
              <img src={icHelpCircle} alt="plan is expired" />
            </Tooltip>
          </div>
          <TextFieldCardCounter
            className={classes.input}
            placeholder={t(
              `${pathKey}:advanceSettingContainer.replySourceUrlInputTitlePlaceholder`,
            )}
            maxCount={0}
            value={value}
            onChange={v => onChange(v)}
            status={isSaved && !value ? 'error' : 'default'}
            isDisable={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default ReplySourceUrl;
